import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError, BehaviorSubject } from 'rxjs';
import { catchError, filter, take, switchMap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { UserService } from './user.service';
import { AuthenticationService } from './authentication.service';
import { environment } from '../../environments/environment';
import { AuthToken } from './interfaces/token.interface';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {

    private isRefreshing = false;
    private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);

    constructor(public authenticationService: AuthenticationService,
        private userService: UserService,
        private router: Router
    ) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (environment.auth.enabled && this.userService.getAccessToken() && !this.isRefreshing && this.include(request.url)) {
            request = this.addToken(request, this.userService.getAccessToken());
        }

        return next.handle(request).pipe(catchError((error: HttpErrorResponse) => {
            if (environment.auth.enabled && error instanceof HttpErrorResponse && error.status === 401) {
                return this.handle401Error(error, request, next);
            //} else if (error instanceof HttpErrorResponse && error.status === 404) {
                //this.router.navigate(['/404']);
            //} else if (error instanceof HttpErrorResponse && error.status === 400 && error.error && error.error.error === 'invalid_grant') {
                // If we get a 400 and the error message is 'invalid_grant', the token is no longer valid so logout.
                //this.authenticationService.authenticate();                
            } else {
                return throwError(() => error);
            }
        }));
        return null;
    }

    private addToken(request: HttpRequest<any>, token: string) {
        return request.clone({
            setHeaders: {
                'Authorization': `Bearer ${token}`
            }
        });
    }

    private handle401Error(error: any, request: HttpRequest<any>, next: HttpHandler) {
        if (this.userService.getRefreshToken()) {
            if (!this.isRefreshing) {
                this.isRefreshing = true;
                this.refreshTokenSubject.next(null);

                return this.authenticationService.refreshToken(this.userService.getRefreshToken()).pipe(
                    switchMap((token: AuthToken) => {
                        this.isRefreshing = false;
                        this.userService.cacheToken(token);
                        this.refreshTokenSubject.next(token.access_token);
                        return next.handle(this.addToken(request, token.access_token));
                    }),
                    catchError((error) => {
                      this.isRefreshing = false;
                      this.authenticationService.authenticate();
                      return throwError(() => error);
                    })
                );
            } else {
                return this.refreshTokenSubject.pipe(
                    filter(token => token != null),
                    take(1),
                    switchMap(access_token => {
                        return next.handle(this.addToken(request, access_token));
                    }));
            }
        } else if (!this.isRefreshing && (request.url.indexOf('/token') > -1)) {
            return throwError(() => error);
        } else {
            this.authenticationService.authenticate();
        }
        return null;
    }

    private include(url: string): boolean {

        if (url.indexOf('/proxy/') > -1) {
            return true;
        } else if (url.indexOf(environment.pvtUrl) === -1
            || url.indexOf('/oauth/token') > -1
            || url.indexOf('/public/providers/signup') > -1
            || url.indexOf('/public/') > -1
        ) {
            return false;
        }

        return true;
    }
}